// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"_12VWgGtjoXcfGqctWiZZdO b-notice-box b-notice-box--info b-notice-box--with-icon","infoIcon":"_3evWuSq3Hg1srNDUCVxvaw b-notice-box__icon"};